import { format, parse } from "date-fns";
import { es } from "date-fns/locale";

const re = /^[0-9]+$/;
const TIMEZONE_OFFSET = 5 * 60;
const FROM_TRYTON = "yyyy-MM-dd";

const getTrytonDate2Js = (value) => {
  if (value) {
    if (value instanceof Date) return value;
    if (typeof value === "string") {
      value = value.split(" ")[0].split("T")[0];
    }
    return parse(value, FROM_TRYTON, new Date(), { locale: es });
  }
};

const getTrytonDate2Fmt = (value, fmt) => {
  const val = parse(value, FROM_TRYTON, new Date());
  return format(val, fmt);
};

const DEFAULT_DATE_FORMAT = "dd MMM yyyy";

const fmtDateTable = (value, formatStr = DEFAULT_DATE_FORMAT) => {
  if (!value) return "";
  if (value instanceof Date) return format(value, formatStr);
  if (!String(value).includes("T")) return value;
  const str = String(value).split(" ")[0].split("T")[0];
  return format(parse(str, FROM_TRYTON, new Date()), formatStr);
};

const getTrytonTime2Js = (value) => {
  if (value) {
    // FIXME: Implement time parsing logic
    const utcTime = parse(value, "HH:mm:ss", new Date());
    return utcTime;
  }
};

const getTrytonDateTimeLocal2Js = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;

  if (typeof value === "string") {
    const [datePart, timePart = "00:00:00"] = value.split("T");

    const [year, month, day] = datePart.split("-").map(Number);

    const [hours = 0, minutes = 0, seconds = 0] = timePart
      .replace("Z", "")
      .split(":")
      .map(Number);

    const OFFSET = 5;
    const totalMinutes = hours * 60 + minutes - OFFSET * 60;
    const localH = Math.floor(
      (((totalMinutes % (24 * 60)) + 24 * 60) % (24 * 60)) / 60,
    );
    const localM = ((totalMinutes % 60) + 60) % 60;

    return new Date(year, month - 1, day, localH, localM, seconds);
  }

  return new Date(value);
};

function eachDayOfInterval(start, end, interval) {
  let current = new Date(start);
  const endDate = new Date(end);

  const dates = [];
  while (current <= endDate) {
    dates.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }
  return dates;
}

const fmtDate = (value) => {
  let _value = value;
  if (value && typeof value === "string") {
    _value = parse(_value, FROM_TRYTON, new Date());
  }
  _value = format(_value, "dd-MM-yyyy");
  return _value;
};

const fmtDatetime = (value) => {
  if (value) {
    const value_ = format(new Date(value), "yyyy-MM-dd HH:mm");
    return value_;
  }
};

const fmtDatetimeForm = (value) => {
  if (value) {
    const value_ = format(value, "dd-MM-yyyy HH:mm");
    return value_;
  }
};

const fmtDatetimeTable = (value, formatStr = true) => {
  if (value) {
    let currentFormat = formatStr;

    if (!currentFormat) {
      currentFormat = "dd-MM-yyyy HH:mm";
    }

    const value_ = format(value, currentFormat);
    // const day = date.getDate();
    // const month = date
    //   .toLocaleString("default", { month: "long" })
    //   .substring(0, 3);
    // const year = date.getFullYear();
    // const hour = format ? `${date.getHours()}:${date.getMinutes()}` : "";
    // const value_ = `${day}/${month}/${year} ${hour}`;
    return value_;
  }
};

const dateToday = () => {
  const _date = new Date();
  return format(_date, "yyyy-MM-dd");
};

const getHour = () => {
  const _date = new Date();
  return format(_date, "HH:mm");
};

const startOfToday = () => {
  const _date = new Date();
  _date.setHours(0, 0, 0, 0);
  return _date;
};

const startOfMonth = (value) => {
  const _date = new Date(value);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
};

const endOfMonth = (value) => {
  const _date = new Date(value);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
};

const endOfWeek = (value) => {
  const _date = new Date(value);
  const day = _date.getDay();
  _date.setDate(_date.getDate() + (6 - day));
  _date.setHours(23, 59, 59, 999);
  return _date;
};

const startOfWeek = (value) => {
  const _date = new Date(value);
  const day = _date.getDay();
  _date.setDate(_date.getDate() - day);
  _date.setHours(0, 0, 0, 0);
  return _date;
};

const fmt = (value, formatStr) => {
  return format(new Date(value), formatStr);
};

const isToday = (value) => {
  const today = format(new Date(), "yyyy-MM-dd");
  return format(value, "yyyy-MM-dd") === today;
};

const isSameMonth = (laterDate, earlierDate) => {
  return (
    laterDate.getFullYear() === earlierDate.getFullYear() &&
    laterDate.getMonth() === earlierDate.getMonth()
  );
};

const startOfDay = (value) => {
  const _date = new Date(value);
  _date.setHours(0, 0, 0, 0);
  return _date;
};

const endOfDay = (value) => {
  const _date = new Date(value);
  _date.setHours(23, 59, 59, 999);
  return _date;
};

// Not necessary, intead use date-fns methods directly
// const dateAdd = (value, delta, diff) => {
//   if (value) {
//     let _date;
//     if (delta == "years") {
//       _date = date.addYears(value, diff);
//     } else if (delta === "months") {
//       _date = date.addMonths(value, diff);
//     } else if (delta === "days") {
//       _date = date.addDays(value, diff);
//     } else if (delta === "weeks") {
//       _date = date.addWeeks(value, diff);
//     }
//     return date.format(_date, "YYYY-MM-DD");
//   }
//   // const _date = new Date();
//   return date.format(value, "YYYY-MM-DD");
// };

const fmtDate2Tryton = (value) => {
  if (value) {
    return format(value, "yyyy-MM-dd");
  }
};

const fmtDatetime2Tryton = (value) => {
  const val = date.addHours(value, 5);
  return format(val, "yyyy-MM-dd HH:mm:ss");
};

const fmtDatetime2Epoch = (value, fromDb) => {
  if (value) {
    let _date;
    if (fromDb) {
      _date = format(value, "yyyy-MM-dd'T'HH:mm");
    } else {
      _date = parse(value, "dd-MM-yyyy | hh:mm a", new Date());
    }
    return _date.getTime() / 1000;
  }
};

const fmtEpochToDatetime = (value) => {
  if (value) {
    const _val = new Date(value * 1000);
    let dateFormatted = format(_val, "yyyy-MM-dd HH:mm:ss", true);
    return dateFormatted;
  }
};

const fmtCurrency = (value) => {
  return value.toLocaleString("es", { useGrouping: true });
};

const isNumber = (value) => {
  return value === "" || re.test(value);
};

function subtractTimeFromDate(objDate, intHours) {
  var numberOfMlSeconds = objDate.getTime();
  var addMlSeconds = intHours * 60 * 60000;
  var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
  return newDateObj;
}

const tools = {
  fmtCurrency,
  fmtDate,
  fmtDatetime,
  fmtDatetimeForm,
  fmtDate2Tryton,
  fmtDatetime2Tryton,
  fmtDatetime2Epoch,
  fmtEpochToDatetime,
  getTrytonDate2Js,
  getTrytonTime2Js,
  getTrytonDateTimeLocal2Js,
  isNumber,
  dateToday,
  eachDayOfInterval,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfToday,
  startOfDay,
  endOfDay,
  fmt,
  isToday,
  isSameMonth,
  subtractTimeFromDate,
  // getTrytonDateTime2Js,
  fmtDatetimeTable,
  getHour,
  getTrytonDate2Fmt,
  fmtDateTable,
  DEFAULT_DATE_FORMAT,
};

export default tools;
